<div class="map-wrapper">
    <div id="mapContainer">
        <!-- <div class="map-title">📍 Drag marker or click on map to get coordinates</div> -->
        @if (show_search_result && searchedData?.length) { <div class="cover-map"></div> }
        <div class="city-section">
            <mat-select class="city-drowdown" placeholder="Select City" [(ngModel)]="selected_place" (selectionChange)="selectionOnChange()">
                   @for (item of getCityList; track $index) {
                        <mat-option [value]="item">{{item.place_label[1]}}</mat-option>
                   }
            </mat-select>
            <div class="property-search">
                <input type="text" class="search-places" 
                [formControl]="searchReport"
                [matTooltip]="place_holder"
                [matTooltipPosition]="'above'"
                placeholder="{{place_holder}}" (click)="showSearch()"/>
                @if(searchText){<mat-icon class="close-icon" (click)="clearSearch()">close</mat-icon>}
                <div [class.search-show]="show_search_result" [class.search-hide]="!show_search_result">
                    @if (searchedData?.length && !searchingLoader) {
                    <div class="searched-group searchSide">
                        @for (data of searchedData; track $index) {
                        <div class="searched-data-container" (click)="locateSearchedParcelOnMap(data)">
                            <div class="map-filter_icns-common">
                                <svg width="12" height="12" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.16667 10.8333L0 9.66667L8 1.66667H0.833333V0H10.8333V10H9.16667V2.83333L1.16667 10.8333Z" fill="#6C737F"/>
                                </svg>
                            </div>
                            <div class="searched-data">
                                <div class="parcel-id"><span
                                        [title]="(data.property_name + (data.project_name ? ' ('+data.project_name+')' : ''))"
                                        class="property_name"
                                        [innerHTML]="(data.property_name + (data.project_name ? ' ('+data.project_name+')' : '')) | highlight : searchText"></span>
                                </div>
                                <div class="neig-block-detail">
                                    <span class="neigh-name">{{data.neigh_name}} </span>
                                    @if(data.neigh_name && data.block_name){<mat-icon>keyboard_arrow_right</mat-icon>}
                                    <span class="block-name">{{data.block_name}}</span>
                                </div>
                            </div>
                        </div>
                        }                
                    </div>
                    }
                    @if(!searchedData?.length && !searchingLoader && searchText){
                        <div class="searched-group no-data text-center">{{'No record found'}}</div>
                    }
                    @if (searchingLoader) {
                        <div class="searched-group">
                            <app-skeleton-loader [reportType]="'searchloader'" [height]="'20px'" [width]="'20px'"></app-skeleton-loader>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div id="map"></div>
        <div class="action-map-btn">
            <button class="cancel-btn" (click)="close()">Cancel</button>
            <button class="next-btn" (click)="next()">Add Location</button>
        </div>
    </div>
</div>